import React, {ChangeEvent, SyntheticEvent} from "react";
import styles from "./index.module.css";
import {Button, Form, Grid, Loader} from "semantic-ui-react";
import agent from "../../agent";
import {Link, Redirect, RouteComponentProps} from "react-router-dom";
import {Test} from "./TestModel";
import {TextAreaProps} from "semantic-ui-react/dist/commonjs/addons/TextArea/TextArea";
import TestIndicatorList from "./TestIndicatorList";
import {Utils} from "../../helpers/Utils";
import { AppMode } from "../../utils/common";
import {hasRole, UserRole} from "../../helpers/UserRole";
import {extractReturnUrl, handleGoBack} from "../../helpers/TablePageUtils";
import { textLabels } from "../../consts/textLabels";

interface MatchParams {
    id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

interface State extends Test {
    editable: boolean,
    loading: boolean,
    saved: boolean,
    editMode: boolean;
    returnUrl: string;
}

class TestEditPage extends React.PureComponent<Props, State> {
    private readonly FALLBACK_URL = "/dashboard/test";

    state: State = {
        editable: false,
        indicators: [],
        dept: {
            _id: "",
            name: ""
        },
        _id: "",
        name: "",
        loading: false,
        editMode: false,
        saved: false,
        returnUrl: this.FALLBACK_URL,
    };

    async componentDidMount() {
        const extractedUrl = extractReturnUrl(this.props.location, this.FALLBACK_URL);
        this.setState({ returnUrl: extractedUrl });
        if (this.props.match && this.props.match.path.includes('edit')) {
            this.setState({editMode: true, loading: true});
            await this.onMount();
        } else {
            this.setState({editable: true})
        }
    };

    onMount = async (): Promise<void> => {
        const testId: string = this.props.match ? this.props.match.params.id : '';
        const doc: Test = await agent.TestProvider.open(testId);

        if (doc) {
            this.setState(doc);
            this.setState({
                loading: false,
            });
        }
    };

    onCreate = async (): Promise<void> => {
        this.setState({loading: true});
        await agent.TestProvider.create(this.state as Test);
        this.setState({loading: false, saved: true});
    };

    onEdit = async () => {
        this.setState({loading: true});

        await agent.TestProvider.edit(this.state).then((doc: Test) => {
            this.setState(doc);
        });

        this.setState({loading: false, saved: true, editable: false});
    };

    isSaveDisabled = (): boolean => {
        return !this.state.name
    };

    handleGoBack = (e: React.MouseEvent) => {
        e.preventDefault();
        handleGoBack(this.props.history, this.state.returnUrl, this.FALLBACK_URL);
    };

    render() {
        const headerLabel: string = this.state.editMode ? `Тип ${Utils.vomode()!=AppMode.PATIENT ? 'документа' : 'анализа'}` : `Создание типа ${Utils.vomode()!=AppMode.PATIENT ? 'документа' : 'анализа'}`;

        return (
            this.state.saved ?
                <Redirect to={this.state.returnUrl || this.FALLBACK_URL}/>
                :
                <div className={styles.testInfoContent}>
                    <div className={styles.testInfoHeader}>
                        {headerLabel}
                    </div>
                    {
                        this.state.loading ?
                            <Loader active/>
                            :
                            <Form>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.Input label={'Наименование'}
                                                        value={this.state.name}
                                                        readOnly={!this.state.editable}
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                            this.setState({name: e.target.value});
                                                        }}
                                            />
                                        </Grid.Column>

                                        <Grid.Column width={3}>
                                            <div className={styles.testEditorButtons}>
                                                {
                                                    this.state.editable ?
                                                        <Button
                                                            className={styles.button}
                                                            color={'green'}
                                                            type={'submit'}
                                                            content={textLabels.saveButton}
                                                            disabled={this.isSaveDisabled()}
                                                            onClick={this.state.editMode ? this.onEdit : this.onCreate}
                                                        />
                                                        :
                                                        <Button
                                                            className={styles.button}
                                                            color={'teal'}
                                                            type={'submit'}
                                                            content={textLabels.editButton}
                                                            onClick={() => this.setState({editable: true})}
                                                            disabled={hasRole(UserRole.OBSERVER)}
                                                        />
                                                }

                                                {!this.state.editable &&
                                                    <Button
                                                        className={styles.button}
                                                        color="grey"
                                                        type="button"
                                                        content={textLabels.returnButton}
                                                        onClick={this.handleGoBack}
                                                    />}

                                                {this.state.editable &&
                                                    <Button
                                                        className={styles.button}
                                                        color={'grey'}
                                                        onClick={() => {
                                                            this.setState({editable: false, saved: true});
                                                        }}
                                                        content={textLabels.cancelButton}
                                                    />}
                                            </div>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={6}>
                                            <Form.TextArea label={'Комментарий'}
                                                           value={this.state.comment?.toString()}
                                                           readOnly={!this.state.editable}
                                                           onChange={(e: SyntheticEvent, data: TextAreaProps) => {
                                                               this.setState({comment: data.value?.toString()});
                                                           }}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column width={10}>
                                            <Form.Field width={"16"}>
                                                <label>
                                                        <Form.Field width={"5"}>
                                                            Показатели {Utils.vomode()!=AppMode.PATIENT ? 'документа' : 'анализа'}
                                                        </Form.Field>
                                                </label>
                                                <TestIndicatorList indicators={this.state.indicators} editing={this.state.editable}/>
                                            </Form.Field>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                    }
                </div>
        )
    }
}

export default TestEditPage;